import { readDocumentResponse } from "../utils/readDocumentResponse";
import { ENV } from "../utils";

export class AirEmissionsform {
  baseApi = ENV.BASE_API;

  async getAirEmissionsForm(accessToken, idAirEmissionsForm) {
    try {
      const url = `${this.baseApi}/airemissions/${idAirEmissionsForm}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async createAirEmissionsForm(accessToken, data) {
    try {
      // const formData = new FormData();
      // Object.keys(data).forEach((key) => {
      //   formData.append(key, data[key]);
      // });
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}`;
      const url = `${this.baseApi}/add-airemissions`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAirEmissionsForms(accessToken, paramsAirEmissions, active = undefined) {
    try {
      const pageFilter = `page=${paramsAirEmissions?.page || 1}`;
      const limitFilter = `limit=${paramsAirEmissions?.limit || 10}`;
      const siteFilter = `site=${paramsAirEmissions?.site || undefined}`
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      let url=`${this.baseApi}/airemissionsforms?${pageFilter}&${limitFilter}`;
      if(active !== undefined){
        url = `${this.baseApi}/airemissionsforms?active=${active}&${pageFilter}&${limitFilter}`;
      }
      if(paramsAirEmissions?.site){
        url = `${url}&${siteFilter}`
      }
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateAirEmissionsForm(accessToken, idAirEmissionsForm, AirEmissionsFormData) {
    try {
      const data = AirEmissionsFormData;

      // const formData = new FormData();
      // Object.keys(data).forEach((key) => {
      //   formData.append(key, data[key]);
      // });

      // const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${ENV.BASE_API}/update-airemissions/${idAirEmissionsForm}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAirEmissionsForm(accessToken, idAirEmissionsForm) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${this.baseApi}/delete-airemissions/${idAirEmissionsForm}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async existsAirEmissionsFormByPeriodAndYear(accessToken, siteId, period, year) {
    try {
      const url = `${this.baseApi}/airemissions-exists-site/${siteId}/${period}/${year}`;
      
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPeriodsAirEmissionsFormsBySiteAndYear(accessToken, siteId, year) {
    try {
      const url = `${this.baseApi}/airemissionsforms-periods-site-year/${siteId}/${year}`;
      
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
  
  async getAirEmissionsFormsBySiteAndYear(accessToken, siteId, year) {
    try {
      const url = `${this.baseApi}/airemissionsforms-site-year/${siteId}/${year}`;
      
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async uploadFileApi(accessToken, data) {
    const url = `${this.baseApi}/upload-file-airemissions/`;

    const params = {
      method: "POST",
      body: data,
      headers: {
        //'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return fetch(url, params)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }

  getFileApi(fileName) {
    const url = `${this.baseApi}/get-file-airemissions/${fileName}`;
    return url;
  }

  async deleteFileApi(accessToken, fileName) {
    const url = `${this.baseApi}/delete-file-airemissions`;

    const params = {
      method: "DELETE",
      body: JSON.stringify({ fileName }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return fetch(url, params)
      .then((response) => {
        return response.url;
      })
      .catch((err) => {
        return err.message;
      });
  }

  async getAirEmissionsFormsByLastYears(accessToken, siteId, years) {
    try {
      const url = `${this.baseApi}/get-last-years-airemissions/${siteId}`;
      
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({years:years}),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getLastUnitFieldsByYear(accessToken, siteId, year, data) {
    try {
      const url = `${this.baseApi}/last-unit-fields-airemissions/${siteId}/${year}`;
      
      const params = {
        method: "POST",
        body: JSON.stringify({fields:data}),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAirEmissionsFormsByLineBaseYears(accessToken, siteId) {
    try {
      const url = `${this.baseApi}/get-linebase-years-airemissions/${siteId}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateUnitsForYear(accessToken, site, year, units) {
    try {
      const url = `${this.baseApi}/airemissions-forms/update-units-year`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ site, year, units }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }

  async batchUpdateAirEmissionsForms(accessToken, data) {
    const url = `${this.baseApi}/airemissions-forms/batch-update`;
    const params = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(url, params);
    return await response.json();
  }

  async readDocument(accessToken, formData) {
    try {
      const url = `${this.baseApi}/airemissions/read-document`;
      const params = {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${accessToken}` },
      };
      const response = await fetch(url, params);
      const result = await readDocumentResponse(response);
      return result;
    } catch (error) {
      throw error;
    }
  }

}

